import React, { useState } from "react";
import toolicon from "../assets/toolicon.png";
import phone2 from "../assets/phone2.png";
import { Link } from "react-router-dom";

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center">
        <div className="flex flex-col items-center md:flex-row md:items-center">
          <img src={toolicon} alt="Name" className="h-14" />
          <img src={phone2} alt="Phone" className="h-6 mt-2 md:mt-0 md:ml-4" />
        </div>

        {/* Kebab Menu Icon */}
        <div className="md:hidden absolute right-4 top-6">
          <button onClick={toggleMenu} className="focus:outline-none">
            <svg
              className="w-6 h-6 text-gray-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
          {isOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
              <Link
                to="/"
                className="block px-4 py-2 text-gray-700 hover:text-primary"
              >
                Home
              </Link>
              <Link
                to="/about-us"
                className="block px-4 py-2 text-gray-700 hover:text-primary"
              >
                About Us
              </Link>
              <Link
                to="/#services"
                className="block px-4 py-2 text-gray-700 hover:text-primary"
              >
                Services
              </Link>
              <Link
                to="/#contact-us"
                className="block px-4 py-2 text-gray-700 hover:text-primary"
              >
                Contact
              </Link>
            </div>
          )}
        </div>

        {/* Navigation Menu */}
        <nav className="hidden md:flex">
          <ul className="flex space-x-4">
            <li>
              <Link to="/" className="text-gray-700 hover:text-primary">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about-us" className="text-gray-700 hover:text-primary">
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/#services"
                className="text-gray-700 hover:text-primary"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/#contact-us"
                className="text-gray-700 hover:text-primary"
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
